"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var networker_1 = require("@idp/networker");
var LegalAPI = /** @class */ (function () {
    function LegalAPI() {
        var _this = this;
        this.getLegal = function (legalPath, callback) {
            var url = legalPath;
            var legalName = legalPath.toString().split('/')[legalPath.toString().split('/').length - 1];
            legalName = legalName.split('.')[0];
            return new Promise(function (resolve, reject) {
                var customHeaders = new Headers();
                customHeaders.append('Access-Control-Allow-Origin', '*');
                new networker_1.Networker().get(url, { headers: customHeaders })
                    // tslint:disable-next-line:no-any
                    .then(function (response) {
                    return response.json();
                })
                    // tslint:disable-next-line:no-any
                    .then(function (data) {
                    resolve(_this.getStaticLegal(data, legalName, callback));
                })
                    .catch(function (error) {
                    reject({ error: error });
                });
            });
        };
        this.getStaticLegal = function (values, legalName, callback) {
            var processedResponse = _this.processAjaxResponse(values, legalName);
            if (callback) {
                callback(processedResponse);
            }
            return processedResponse;
        };
        // tslint:disable-next-line:no-any
        this.parseJsonResponse = function (response, legalName) {
            var legalLongPathall = response['idp-cms-feed'][legalName].master.legalLongPath;
            var legalLongPath = '';
            var item;
            for (var _i = 0, legalLongPathall_1 = legalLongPathall; _i < legalLongPathall_1.length; _i++) {
                item = legalLongPathall_1[_i];
                legalLongPath = legalLongPath.concat(item.master.legalText);
            }
            // tslint:disable-next-line:no-any
            var returnResponse = {
                longtext: legalLongPath,
                modalID: response['idp-cms-feed'][legalName].master.legalModalID,
                modaltitle: response['idp-cms-feed'][legalName].master.legalModalTitle,
            };
            return returnResponse;
        };
        // tslint:disable-next-line:no-any
        this.processAjaxResponse = function (response, legalName) {
            // tslint:disable-next-line:no-any
            var legalContent = _this.parseJsonResponse(response, legalName);
            legalContent.longtext = legalContent.longtext;
            return legalContent;
        };
    }
    return LegalAPI;
}());
exports.default = LegalAPI;
//# sourceMappingURL=LegalAPI.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/api/LegalAPI.js
// module id = 257
// module chunks = 8